import { Button, Divider, Grid, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IntakeCart } from "../../types/slices/intakeCartType";
import { useProductEntryStore } from "../../hooks/useProductEntryStore";
import { ApiStatus } from "../../types/api/status";
import { useIntakeCartStore } from "../../hooks/useIntakeCartStore";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { moneyCL } from "../../toolbox/helpers/money-helpers";
import { RoutesMap } from "../../types";

const columns = [
    { type: 'text', field: 'code_system', label: 'Codigo', align: 'center' },
    { type: 'text', field: 'product', label: 'Producto', align: 'center' },
    { type: 'text', field: 'unitmeasure_abbreviation', label: 'Und. Med.', align: 'center' },
    { type: 'text', field: 'quantity', label: 'Cantidad', align: 'center' },
    { type: 'text', field: 'cost', label: 'Costo', align: 'center', format: (row) => moneyCL(row.cost) },
    { type: 'text', field: 'net_subtotal', label: 'Total ($)', align: 'center', format: (row) => moneyCL(row.cost * row.quantity) },
];

const StyledTableCell = ({ children, ...props }) => (
    <TableCell sx={{ border: '1px solid #000000', ...props.sx }}>
        {children}
    </TableCell>
);

export const ProductEntryPreview: FC = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const { status: statusProductEntry } = useProductEntryStore()
    const { status: statusIntake, getIntakeKart } = useIntakeCartStore()
    const { status: statusEntry, createProductEntry } = useProductEntryStore()

    const [intakeCart, setIntakeCart] = useState<IntakeCart | undefined>(undefined)
    const [costTotal, setCostTotal] = useState<number>(0)

    useEffect(() => {
        getIntakeCartAPI()
    }, [])

    const getIntakeCartAPI = async () => {
        const resp = await getIntakeKart({ id: id })
        if (resp.length > 0) {
            setIntakeCart(resp[0])
            const costTotal = resp[0]?.details.reduce((acc, row) => acc + (row.quantity * row.cost), 0)
            setCostTotal(costTotal)
        }
    }

    const goBack = () => {
        navigate(-1)
    }

    const onCreateProductEntry = async () => {
        const resp = await createProductEntry({ idintake_cart: id })
        if (resp === true) {
            navigate({ pathname: RoutesMap.INTAKE_CART })
        }
    }

    return (
        <Grid container spacing={2}>

            {/* Información */}
            <Grid item xs={12} md={7} sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography>{intakeCart?.company.toUpperCase()}</Typography>
                <Typography>{intakeCart?.giro_company}</Typography>
                <Typography>{intakeCart?.address_company}</Typography>
                <Typography>Región Metropolitana - Chile</Typography>
                <Typography>Fonos: {intakeCart?.phone_company}</Typography>
                <Typography>www.softnet.cesione.cl - www.softnet.recepcione.cl</Typography>
            </Grid>
            <Grid item xs={12} md={5} sx={{ display: 'flex', flexDirection: 'column' }}>
                <Grid sx={{
                    alignItems: 'center',
                    border: '2px solid #000000',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    padding: '15px 0px'
                }}>
                    <Typography sx={{ color: '#000000', fontWeight: 'bolder', margin: '5px' }}>R.U.T.: {intakeCart?.rut_company}</Typography>
                    <Typography sx={{ color: '#000000', fontWeight: 'bolder', margin: '5px' }}>GUIA DE INGRESO</Typography>
                    <Typography sx={{ color: '#000000', fontWeight: 'bolder', margin: '5px' }}>N° {intakeCart?.id}</Typography>
                </Grid>
                <Typography sx={{ color: '#000000', fontWeight: 'bolder', margin: '10px auto' }}>S.I.I.- SANTIAGO ORIENTE</Typography>
                <Typography sx={{ marginLeft: 'auto' }}>Santiago, {intakeCart?.date_format}</Typography>
            </Grid>
            {/* <Grid item container xs={12} md={12} sx={{ borderBottom: '4px solid #516E80', marginLeft: '16px' }}>
                <Typography sx={{ backgroundColor: '#516E80', color: '#fff', marginRight: 'auto', padding: '5px 10px', marginLeft: '-16px' }}>Datos del cliente</Typography>
            </Grid>
            <Grid item container xs={12} md={6}>
                {/* <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', borderTop: '2px solid #858585', height: '30px' }}>
                    <Typography sx={{
                        backgroundColor: '#F5F5F5',
                        color: '#000000',
                        fontWeight: 'bolder',
                        height: '100%',
                        marginRight: 'auto',
                        padding: '5px',
                        width: '100%',
                    }}
                    >
                        RUT / NIT / DNI
                    </Typography>
                </Grid>
                 <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', borderTop: '2px solid #858585', height: '30px' }}>
                    <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}>{intakeCart?.rut_customer}</Typography>
                </Grid>
                <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '30px' }}>
                    <Typography sx={{
                        backgroundColor: '#F5F5F5',
                        color: '#000000',
                        fontWeight: 'bolder',
                        height: '100%',
                        marginRight: 'auto',
                        padding: '5px',
                        width: '100%',
                    }}
                    >
                        {'Señor(es)'}
                    </Typography>
                </Grid>
                <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '30px' }}>
                    <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}>{intakeCart?.name_customer.toUpperCase()}</Typography>
                </Grid>
                <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '30px' }}>
                    <Typography sx={{
                        backgroundColor: '#F5F5F5',
                        color: '#000000',
                        fontWeight: 'bolder',
                        height: '100%',
                        marginRight: 'auto',
                        padding: '5px',
                        width: '100%'
                    }}
                    >
                        Giro
                    </Typography>
                </Grid>
                <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '30px' }}>
                    <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}>{intakeCart?.giro_customer.toUpperCase()}</Typography>
                </Grid> 
            </Grid> */}
            {/* <Grid item container xs={12} md={6} sx={{
                [theme.breakpoints.up('md')]: { paddingLeft: '0 !important' },
                [theme.breakpoints.down('md')]: { paddingTop: '0 !important' }
            }}>
                <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '30px' }}>
                    <Typography sx={{
                        backgroundColor: '#F5F5F5',
                        color: '#000000',
                        fontWeight: 'bolder',
                        height: '100%',
                        marginRight: 'auto',
                        padding: '5px',
                        width: '100%',
                        [theme.breakpoints.up('md')]: { borderTop: '2px solid #858585' }
                    }}
                    >
                        Dirección
                    </Typography>
                </Grid>
                <Grid item xs={6}
                    sx={{
                        borderBottom: '2px solid #858585',
                        height: '30px',
                        [theme.breakpoints.up('md')]: { borderTop: '2px solid #858585' }
                    }}>
                    <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}>{intakeCart?.client_address?.toUpperCase()}</Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3} sx={{ borderBottom: '2px solid #858585', height: '30px' }}>
                    <Typography sx={{
                        backgroundColor: '#F5F5F5',
                        color: '#000000',
                        fontWeight: 'bolder',
                        height: '100%',
                        marginRight: 'auto',
                        padding: '5px',
                        width: '100%'
                    }}
                    >
                        Distrito
                    </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3} sx={{ borderBottom: '2px solid #858585', height: '30px' }}>
                    <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}>{intakeCart?.district_customer.toUpperCase()}</Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3} sx={{ borderBottom: '2px solid #858585', height: '30px' }}>
                    <Typography sx={{
                        backgroundColor: '#F5F5F5',
                        color: '#000000',
                        fontWeight: 'bolder',
                        height: '100%',
                        marginRight: 'auto',
                        padding: '5px',
                        width: '100%'
                    }}
                    >
                        Provincia
                    </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3} sx={{ borderBottom: '2px solid #858585', height: '30px' }}>
                    <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}>{intakeCart?.province_customer.toUpperCase()}</Typography>
                </Grid>
                <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '30px' }}>
                    <Typography sx={{
                        backgroundColor: '#F5F5F5',
                        color: '#000000',
                        fontWeight: 'bolder',
                        height: '100%',
                        marginRight: 'auto',
                        padding: '5px',
                        width: '100%'
                    }}
                    >
                        País
                    </Typography>
                </Grid>
                <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '30px' }}>
                    <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px', lineHeight: '100%', }}>{intakeCart?.country_customer.toUpperCase()}</Typography>
                </Grid>
            </Grid> */}

            {/* Detalle */}
            <Grid item container xs={12} md={12} sx={{ borderBottom: '4px solid #516E80', marginLeft: '16px', marginTop: '20px' }}>
                <Typography sx={{ backgroundColor: '#516E80', color: '#fff', marginRight: 'auto', padding: '5px 10px', marginLeft: '-16px' }}>
                    Detalle
                </Typography>
            </Grid>
            <Grid item container xs={12} sx={{ marginTop: '-38px' }}>
                <CustomTable
                    columns={columns}
                    rows={intakeCart?.details || []}
                    withoutPagination
                    colorColumns={'#516E80'}
                    onRowClick={() => null}
                    dense
                />
            </Grid>
            <Grid item container xs={12}>
                <Grid item xs={4} sx={{ marginLeft: 'auto' }}>
                    <TableContainer>
                        <Table size="small">
                            <TableBody>
                                {/* <TableRow key={1}>
                                    <StyledTableCell align='center' sx={{ background: '#516E80', color: '#fff' }}>
                                        Subtotal
                                    </StyledTableCell>
                                    <StyledTableCell align='center'>{moneyCL(intakeCart.sub_total)}</StyledTableCell>
                                </TableRow>
                                <TableRow key={1}>
                                    <StyledTableCell align='center' sx={{ background: '#516E80', color: '#fff' }}>
                                        Descuento
                                    </StyledTableCell>
                                    <StyledTableCell align='center'>{moneyCL(intakeCart.total_discount)}</StyledTableCell>
                                </TableRow>
                                <TableRow key={1}>
                                    <StyledTableCell align='center' sx={{ background: '#516E80', color: '#fff' }}>
                                        Monto Neto
                                    </StyledTableCell>
                                    <StyledTableCell align='center'>{moneyCL(intakeCart.net_total)}</StyledTableCell>
                                </TableRow>
                                {
                                    idtype_document === 2 &&
                                    <TableRow key={1}>
                                        <StyledTableCell align='center' sx={{ background: '#516E80', color: '#fff' }}>
                                            Monto Excento
                                        </StyledTableCell>
                                        <StyledTableCell align='center'>{moneyCL(0)}</StyledTableCell>
                                    </TableRow>
                                }
                                <TableRow key={2}>
                                    <StyledTableCell align='center' sx={{ background: '#516E80', color: '#fff' }}>
                                        19% IVA
                                    </StyledTableCell>
                                    <StyledTableCell align='center'>{moneyCL(intakeCart.IVA)}</StyledTableCell>
                                </TableRow> */}
                                <TableRow key={3}>
                                    <StyledTableCell align='center' sx={{ background: '#516E80', color: '#fff' }}>
                                        TOTAL
                                    </StyledTableCell>
                                    <StyledTableCell align='center'>{moneyCL(costTotal)}</StyledTableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>

            <Grid item xs={12}>
                <Divider />
            </Grid>

            <Grid container justifyContent="center" spacing={5} sx={{ marginTop: '-15px' }}>
                <Grid item>
                    <Button
                        sx={{
                            backgroundColor: '#ffffff',
                            border: '1px solid #516E80',
                            borderRadius: '10px',
                            color: '#516E80',
                            height: '25px',
                            padding: '6px 16px',
                            textTransform: 'none',
                            width: 200,
                            "&:hover": { backgroundColor: "#ffffff" }
                        }}
                        onClick={goBack}
                        disabled={statusProductEntry === ApiStatus.FETCHING}
                    >
                        Volver
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        sx={{
                            backgroundColor: '#516E80',
                            borderRadius: '10px',
                            color: '#ffffff',
                            height: '25px',
                            padding: '6px 16px',
                            textTransform: 'none',
                            width: 200,
                            "&:hover": { backgroundColor: "#516E80" }
                        }}
                        onClick={() => onCreateProductEntry()}
                        disabled={statusIntake === ApiStatus.FETCHING || statusEntry === ApiStatus.FETCHING}
                    >
                        Realizar ingreso
                    </Button>
                </Grid>
                {/* <Grid item>
                    <Button
                        sx={{
                            backgroundColor: '#516E80',
                            borderRadius: '10px',
                            color: '#ffffff',
                            height: '25px',
                            padding: '6px 16px',
                            textTransform: 'none',
                            width: 200,
                            "&:hover": { backgroundColor: "#516E80" }
                        }}
                        onClick={onCreateSalesDocument}
                    >
                        {status === ApiStatus.FETCHING ? <CircularProgress size={24} color="inherit" /> : 'Facturar'}
                    </Button>
                </Grid> */}
            </Grid>
        </Grid>
    )
}